// extracted by mini-css-extract-plugin
module.exports = {"melodyVideo":"gw","landingPageVideo":"hw","play":"iw","iframeVideo":"jw","playHidden":"kw","playVisible":"lw","fullwidth":"mw"};